import React, { FC, useState } from 'react';
import { Button, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import LocalModal from 'components/base/local-modal';
import { handleApiError } from 'utils/functions';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

interface CreateSaReferralCodeFooterProps {
  onConfirm: () => void;
  loading: boolean;
  disabled: boolean;
}

const CreateSaReferralCodeFooter: FC<CreateSaReferralCodeFooterProps> = ({
  onConfirm,
  loading,
  disabled
}) => (
  <div className='flex justify-end'>
    <Button
      small
      color='primary'
      variant='block'
      className='max-w-fit'
      onClick={onConfirm}
      loading={loading}
      disabled={disabled}>
      Confirm
    </Button>
  </div>
);

const CreateSaReferralCodeModal = ({ isOpen, onClose }: Props) => {
  const defaultFormState = {
    email: '',
    phoneNumbers: ['']
  };
  const [loading, setLoading] = useState(false);
  const [formState, setFormState] = useState(defaultFormState);

  const onConfirm = async () => {
    try {
      setLoading(true);
      const res = await apiService.post('referral', {
        data: {
          email: formState.email,
          phone_numbers: formState.phoneNumbers
        }
      });
      toast(<ToastMessage type='success' message={res.data.message} />);
      setFormState(defaultFormState);
      onClose();
    } catch (error) {
      onClose();
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  const confirmButtonDisabled =
    loading || !formState.email || !formState.phoneNumbers.every((phone) => Boolean(phone));

  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const newPhoneNumbers = [...formState.phoneNumbers];
    newPhoneNumbers[index] = e.target.value;
    setFormState({ ...formState, phoneNumbers: newPhoneNumbers });
  };

  const handleAddPhoneNumber = () => {
    setFormState({ ...formState, phoneNumbers: [...formState.phoneNumbers, ''] });
  };
  const handleRemovePhoneNumber = () => {
    const newPhoneNumbers = [...formState.phoneNumbers];
    newPhoneNumbers.pop();
    setFormState({ ...formState, phoneNumbers: newPhoneNumbers });
  };
  return (
    <LocalModal
      isOpen={isOpen}
      onRequestClose={onClose}
      title='Create Student Ambassador Referral Code'
      footer={
        <CreateSaReferralCodeFooter
          onConfirm={onConfirm}
          loading={loading}
          disabled={confirmButtonDisabled}
        />
      }>
      <div>
        <Input
          type='email'
          label='Email'
          value={formState.email}
          onChange={(e) => setFormState({ ...formState, email: e.target.value })}
          className='mb-6'
          placeholder='Email'
          inputClass='h-[50px]'
        />

        {formState.phoneNumbers.map((phoneNumber, index) => (
          <Input
            key={index}
            type='tel'
            label={`Phone Number ${index + 1}`}
            value={phoneNumber}
            onChange={(e) => handlePhoneNumberChange(e, index)}
            className='mb-6'
            placeholder='Phone Number'
            inputClass='h-[50px]'
          />
        ))}
        <div className='flex items-center justify-end gap-4'>
          {formState.phoneNumbers.length > 1 && (
            <Button
              small
              color='primary'
              variant='link'
              className='max-w-fit'
              onClick={handleRemovePhoneNumber}>
              Remove
            </Button>
          )}

          <Button
            small
            color='blue'
            variant='link'
            className='max-w-fit'
            onClick={handleAddPhoneNumber}>
            Add
          </Button>
        </div>
      </div>
    </LocalModal>
  );
};

export default CreateSaReferralCodeModal;
